import { render, staticRenderFns } from "./TermsListDefaultLayout.vue?vue&type=template&id=e52124e0&scoped=true&"
import script from "./TermsListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./TermsListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52124e0",
  null
  
)

export default component.exports